import {
  GrainUsageTypeEnum,
  ROUTE_PARTIES_GRAIN_ADD,
} from '@/common/constants';
import { Heading } from '@/components/heading/Heading';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Plus } from 'lucide-react';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import usePartyGrainStore from '../../store/usePartyGrainStore';
import { PartiesTable } from './parties-table';
import PartiesFilter from './PartiesGrainFilter';
import { PlaceTable } from './place-table';

export const PartiesGrainWrapper: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fetchPartiesGrain } = usePartyGrainStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab =
    (searchParams.get('activeTab') as GrainUsageTypeEnum) ||
    GrainUsageTypeEnum.SEED;

  const setActiveTab = (value: GrainUsageTypeEnum) => {
    setSearchParams((prev) => {
      prev.set('activeTab', value);
      prev.set('page', '1');
      return prev;
    });
  };

  const pageSize = Number(searchParams.get('size')) || 10;
  const currentPage = Number(searchParams.get('page')) || 1;
  const searchKeyword = searchParams.get('search_keyword') || '';

  useEffect(() => {
    fetchPartiesGrain({
      page: currentPage,
      size: pageSize,
      usage_type: activeTab || GrainUsageTypeEnum.SEED,
      search_keyword: searchKeyword,
    });
  }, [pageSize, currentPage, activeTab, searchKeyword]);

  const handleClick = () => {
    navigate(`${ROUTE_PARTIES_GRAIN_ADD}?activeTab=${activeTab}`);
  };

  return (
    <div className="flex flex-col py-8 px-10 w-full  h-screen space-y-6">
      <Tabs
        value={activeTab}
        onValueChange={(value) => {
          setActiveTab(value as GrainUsageTypeEnum);
        }}
      >
        <div className="flex-h-center-between">
          <div className="flex flex-col gap-6">
            <Heading title="parties" />
            <TabsList>
              <TabsTrigger
                value={GrainUsageTypeEnum.SEED}
                className="min-w-[98px]"
              >
                {t('party')}
              </TabsTrigger>
              <TabsTrigger
                value={GrainUsageTypeEnum.GOODS}
                className="min-w-[98px]"
              >
                {t('place')}
              </TabsTrigger>
            </TabsList>
          </div>

          <Button
            variant="outline"
            className="text-gray-900 text-sm font-medium"
            onClick={handleClick}
          >
            <Plus size="20" color="green" />
            {activeTab === GrainUsageTypeEnum.SEED
              ? t('add.parties')
              : t('add.places')}
          </Button>
        </div>
        <div className="mt-8">
          <PartiesFilter activeTab={activeTab} />
        </div>
        <TabsContent value={GrainUsageTypeEnum.SEED} className="h-full mt-8">
          <PartiesTable />
        </TabsContent>
        <TabsContent value={GrainUsageTypeEnum.GOODS} className="h-full mt-8">
          <PlaceTable />
        </TabsContent>
      </Tabs>
    </div>
  );
};
